<!-- 媒体swiper -->
<template>
  <div
    class="media-swiper"
    :class="{
      'media-swiper--thumb': type === 'thumb',
    }"
    @mouseover="mouseOver"
    @mouseleave="mouseLeave"
  >
    <!-- 开启放大镜或则图片少于2个的话，禁用滑动 -->
    <swiper
      ref="mySwiper"
      class="swiper"
      :class="{
        'swiper-no-swiping': data.length <= 1 || enablePicZoom,
      }"
      :options="options"
      @slideChange="slideChange"
      @slideChangeTransitionEnd="handleChangeEnd"
    >
      <swiper-slide v-for="(item, index) in data" :key="rowKey ? item['rowKey'] : index">
        <!-- 缩略图 -->
        <template v-if="type === 'thumb'">
          <div class="media-swiper__thumb">
            <i
              v-if="item.media_content_type === 'external_video' || item.media_content_type === 'video'"
              class="media-swiper__video-icon"
              :class="{
                'iconfont icon-cm-youtube': item.media_content_type === 'external_video',
                'el-icon-video-play': item.media_content_type === 'video',
              }"
            />
            <v-lazy-img :src="item.thumbnail" :data-url="item.url" />
          </div>
        </template>
        <template v-else>
          <div
            class="media-swiper__slide-card"
            v-if="enablePicZoom && (item.media_content_type == 'image' || item.media_content_type == 'external_image')"
          >
            <!-- 放大镜 -->
            <pic-zoom class="media-swiper__zoom" @load="swiper.update()" :url="item.url" :bigUrl="item.url" :appendToBody="true" />
          </div>
          <!-- 媒体卡片 -->
          <media-card
            v-else
            :type="item.media_content_type"
            :src="item.url"
            :url="item.url"
            :thumbnail="item.thumbnail"
            :show-play-button="false"
            :muted="true"
            @imageLoad="swiper && swiper.update()"
            class="media-swiper__slide-card"
          />
        </template>
      </swiper-slide>
    </swiper>

    <!-- 左右导航 -->
    <template v-if="showNavButton && data.length > 1">
      <div class="media-swiper__prev"
        :class="{
          animation: navAnimation
        }"
      >
        <svg viewBox="0 0 100 100">
          <path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path>
        </svg>
      </div>
      <div class="media-swiper__next"
        :class="{
          animation: navAnimation
        }"
      >
        <svg viewBox="0 0 100 100">
          <path
            d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z"
            class="arrow"
            transform="translate(100, 100) rotate(180) "
          ></path>
        </svg>
      </div>
    </template>
  </div>
</template>

<script>

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
//import LazyImg from '@/js/components/LazyImg.vue'
import MediaCard from '@/js/components/MediaCard.vue'
import PicZoom from '@/js/components/common/picZoom.vue'

export default {
  name: 'MediaSwiper',
  components: {
    swiper,
    swiperSlide,
    MediaCard,
    PicZoom,
  },
  model: {
    prop: 'activeIndex',
    event: 'change',
  },
  emits: ['change', 'endChange'],
  props: {
    // swiper配置
    options: {
      type: Object,
      require: true,
    },
    // 数据
    data: {
      type: Array,
      require: true,
    },
    // 当前点中的swiper
    activeIndex: {
      type: Number,
      default: 0,
    },
    // key
    rowKey: {
      type: String,
      default: null,
    },
    // 放大镜功能
    enablePicZoom: {
      type: Boolean,
      default: false,
    },
    // showNavButton, 左右两边导航按钮
    showNavButton: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: null,
    },
    // 导航动画
    navAnimation: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mounted: (this.type === 'thumb' && !this.options?.loop) ? false : true
    }
  },
  methods: {
    // 跳转到
    slideTo(index) {
      if (!this.mounted) {
        const toIndex = index
        setTimeout(() => {
          this.mounted = true
          this.swiper.slideTo(toIndex)
        }, 600)
      } else {
        if (this.options?.loop) {
          this.swiper.slideToLoop(index)
        } else {
          this.swiper.slideTo(index)
        }
      }
    },
    // 下一个
    next() {
      this.swiper.slideNext()
    },
    // 上一个
    prev() {
      this.swiper.slidePrev()
    },
    /**
     * slide变化
     */
    slideChange() {
      const { realIndex, activeIndex } = this.swiper

      if (this.mounted) {
        if (this.options?.loop) {
          if (realIndex !== activeIndex) {
            this.$emit('change', realIndex)
          }
        } else {
          this.$emit('change', realIndex)
        }

        // 校正，用于修复开启自动轮播，放大镜失效的问题
        if (activeIndex > this.data.length) {
          const { autoplay } = this.options
          if (autoplay && this.enablePicZoom) {
            this.slideTo(realIndex)
          }
        }
      }
    },
    /**
     * 切换结束
     */
    handleChangeEnd() {
      const { realIndex } = this.swiper
      this.$emit('endChange', realIndex)
    },
    /**
     * 开启或关闭自动轮播
     */
    play(val) {
      if (val) {
        this.swiper?.autoplay?.start()
      } else {
        this.swiper?.autoplay?.stop()
      }
    },
    /**
     * 鼠标进入
     */
    mouseOver() {
      const { autoplay } = this.options

      const meidaType = this.data[this.activeIndex]?.media_content_type

      if (this.enablePicZoom && autoplay) {
        if (['external_image', 'image'].includes(meidaType)) {
          this.play(false)
        }
      }
    },
    /**
     * 鼠标移出
     */
    mouseLeave() {
      // 当前是开启放大镜
      // 当前是视频的话不用去关心
      const { autoplay } = this.options
      if (this.enablePicZoom && autoplay) {
        const meidaType = this.data[this.activeIndex]?.media_content_type

        if (['external_image', 'image'].includes(meidaType)) {
          this.play(true)
        }
      }
    },
  },
  mounted() {
    if (!this.mounted) {
      setTimeout(() => {
        this.mounted = true
      }, 600)
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    },
  },
  watch: {
    // 监听index变化，并跳转到该index
    activeIndex(newIndex) {
      if (!this.swiper) return
      const { realIndex, activeIndex } = this.swiper

      if (newIndex !== realIndex) {
        this.slideTo(newIndex)
      }
      // 特殊情况
      else {
        if (realIndex === activeIndex && realIndex == newIndex) {
          this.slideTo(newIndex)
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.media-swiper {
  position: relative;
  // 缩略图
  &--thumb {
    // padding-left: 30px;
    // padding-right: 30px;
    .media-swiper {
      &__prev, &__next {
        display: none;
        // background-color: #ccc;
        color: #fff;
      }
      &__prev {
        background-image: linear-gradient(to right, #000 , rgba(255, 255, 255, 0));
      }
      &__next {
        background-image: linear-gradient(to left, #000 , rgba(255, 255, 255, 0));
      }
    }
    &:hover {
      .media-swiper {
        &__prev, &__next {
          &:not(.swiper-button-disabled) {
            display: flex;
          }
        }
      }
    }
  }
  &__thumb {
    cursor: pointer;
    position: relative;
    margin-right: 12px;
    height: 64px;
    width: 64px;
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
  &__slide-card {
    text-align: center;
    ::v-deep {
      .v-media-card {
        &__media {
          img {
            width: 100%;
          }
        }
      }
    }
  }
  // 放大镜
  &__zoom {
    width: 100%;
    ::v-deep {
      .wrap {
        width: 100%;
        display: block;
        & > div {
          display: block !important;
          width: 100% !important;
        }
      }
    }
  }
  // 视屏图标
  &__video-icon {
    position: absolute;
    z-index: 2;
    font-size: 30px;
    color: #fff;
    height: 100%;
    width: 100%;
    background: #00000035;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__prev,
  &__next {
    position: absolute;
    height: 100%;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    top: 0;
    font-size: 24px;
    font-weight: bold;
    svg {
      stroke-width: 4px;
      stroke: currentColor;
    }
  }
  &__prev {
    left: 0;
    &.animation {
      &:not(.swiper-button-disabled) {
        &:hover {
          svg {
            animation: buttonFromRightToLeft 0.5s ease-in-out forwards;
          }
        }
      }
    }
  }
  &__next {
    right: 0;
    &.animation {
      &:not(.swiper-button-disabled) {
        &:hover {
          svg {
            animation: buttonFromLeftToRight 0.5s ease-in-out forwards;
          }
        }
      }
    }
  }

  ::v-deep {
    .swiper-slide-active {
      .media-swiper {
        &__thumb {
          cursor: auto;
          &::before {
            position: absolute;
            z-index: 3;
            height: 100%;
            width: 100%;
            border: 2px solid var(--main-btn-bg);
            content: '';
            top: 0;
          }
        }
      }
    }
    .swiper-button-disabled {
      display: none;
      // color: #ccc;
      // cursor: not-allowed;
    }
  }
}
</style>
